import { Loader } from '@components/Loader';

export const PageLoader = () => <Loader wrapperProps={{ mt: '10%' }} />;
